<template>
    <div class="welfare block">
        <div class="welfare-content">
            <el-select v-model="phase" placeholder="Select" class="welfare-select">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
            <div class="welfare-grid">
                <div class="welfare-table-wrap">
                    <h4 style="margin-bottom: 10px; font-size: 14px">Thông tin chi tiết:</h4>
                    <el-table
                        :data="dataDetails"
                        border
                        class="welfare-table">
                        <el-table-column
                            prop="label"
                            label="Giai đoạn"
                            width="260">
                        </el-table-column>
                        <el-table-column
                            prop="value"
                            label="Được chuyển nhượng/Bán"
                            width="220">
                        </el-table-column>
                    </el-table>
                </div>
                <div class="welfare-table-wrap">
                    <h4 style="margin-bottom: 10px; font-size: 14px">Giá trị trái phiếu tích lũy từng năm:</h4>
                    <el-table
                        :data="dataBondYear"
                        border :show-header="false"
                        class="welfare-table">
                        <el-table-column
                            prop="label"
                            width="260">
                        </el-table-column>
                        <el-table-column
                            prop="value"
                            width="220">
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {GET_DETAIL_BOND_VALUE} from "../../../../core/services/store/service.module";
import {formatDate} from "@/core/filters";

export default {
    name: "Welfare",
    data()
    {
        return {
            dataDetails: [],
            dataBondYear: [],
            phase: 0,

            options: [
                {
                    label: 'Mốc tích lũy 1',
                    value: 1
                },
                {
                    label: 'Mốc tích lũy 2',
                    value: 2
                },
                {
                    label: 'Mốc tích lũy 3',
                    value: 3
                },
                {
                    label: 'Mốc tích lũy 4',
                    value: 4
                },
                {
                    label: 'Mốc tích lũy 5',
                    value: 5
                }
            ],
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        formatDate,
        formatMoney(value){
            value = value.toLocaleString('it-IT', {style : 'currency', currency : 'VND'});
            return value
        },
        getData()
        {
            this.$store.dispatch(GET_DETAIL_BOND_VALUE).then((data) => {
                this.dataBonds = data?.data?.map(item => {
                    this.phase = item?.milestone
                    return item
                })
                this.filterBond()
            }).finally(() => {
                this.loadingDetail = false;
            })
        },
        filterBond() {
            if (this.dataBonds.length > 0) {
                const newData = this.dataBonds.filter(item => item?.milestone === this.phase);
                if (newData.length > 0) {
                    newData?.map(e => {
                        this.getDetails(e)
                    })
                } else {
                    this.getDetails()
                }
                let years = newData[0]?.items?.map((item,index)=>{
                    return item.year_number
                })
                this.dataBondYear = [1,2,3,4,5,6,7].map((year,index) => {
                    if(years?.includes(year)){
                        let data = newData[0]?.items?.find((item)=>item.year_number === year)
                        console.log(data);
                        return {
                            label: `Năm ${year}`,
                            value: data?.amount ? this.formatMoney(data?.amount) : 'Chưa có dữ liệu'
                        }
                    }
                    return {
                        label: `Năm ${year}`,
                        value: 'Chưa có dữ liệu'
                    }

                })
            }
        },
        getDetails(data) {
            this.dataDetails = ['start_date', 'end_date', 'allowed_sale_date', 'amount_total', 'amount_sold', 'amount_balance'].map(item => {
                return {
                    label: this.convertKeyToString(item),
                    value: data ? this.formatData(data, item) : 'Chưa có dữ liệu',
                }
            })
        },
        formatData(data, key) {
            switch (key) {
                case 'start_date':
                case 'end_date':
                case 'allowed_sale_date':
                    return this.formatDate(data[key])
                case 'amount_total':
                case 'amount_sold':
                case 'amount_balance':
                    return this.formatMoney(data[key])
                default:
                    return 'Chưa có dữ liệu'
            }
        },
        convertKeyToString(key) {
            if (key) {
                switch (key) {
                    case "start_date":
                        return 'Thời điểm bắt đầu tích lũy'
                    case "end_date":
                        return 'Thời điểm trái phiếu có hiệu lực'
                    case "allowed_sale_date":
                        return 'Thời điểm được chuyển nhượng/bán'
                    case "amount_total":
                        return 'Tổng giá trị trái phiếu'
                    case "amount_sold":
                        return 'Số lượng TP đã bán/chuyển nhượng'
                    case "amount_balance":
                        return 'Số lượng TP còn lại'
                }
            }
        },
    }
}
</script>

<style scoped>
.welfare {
    width: 100%;
    min-width: 0;
}

.welfare-content {
    max-height: 500px;
    margin-top: -20px;
    overflow-y: auto;
    overflow-x: hidden;
}

.welfare-select {
    width: 260px;
    max-width: 100%;
}

.welfare-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px;
    margin-top: 20px;
}

.welfare-table-wrap {
    min-width: 0;
    overflow-x: auto;
}

.welfare-table {
    min-width: 480px;
}

@media (max-width: 991.98px) {
    .welfare-grid {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 575.98px) {
    .welfare-content {
        overflow-x: visible;
    }

    .welfare-table {
        min-width: 430px;
    }
}
</style>
